import styled from 'styled-components'

import Button from 'components/Button/Button'
import AutoTable from 'components/AutoTable'
import { themeGet } from 'styled-system'

export const StyledAutoTable = styled(AutoTable)`
  margin-top: 1rem;
`
export const ExampleImage = styled.img`
  display: flex;
  width: 100%;
`

export const Instructions = styled.span`
  display: flex;
  font-family: Molde-bold;
  padding: 0.6rem 0;
`

export const ResultsSection = styled.div`
  margin: 1rem 0rem;
  max-height: 500px;
  overflow-y: auto;

  & a {
    color: ${themeGet('colors.blue')};
  }

  & a:hover {
    color: ${themeGet('colors.darkBlue')};
  }
`

export const UploadButton = styled(Button)`
  margin: 5px;
  color: '#002855';
`

export const UploadSection = styled.div`
  display: flex;
  padding: 1rem 0 0.5rem;
  justify-content: flex-end;
`

export const TemplateLinkWrapper = styled.div`
  a {
    color: ${themeGet('colors.blue')};
  }
`
